<template>
  <v-container fluid text-xs-center>
  <v-dialog v-model="calendar" max-width="500px">
    <v-card>
      <date-range
        class="calendar"
        :lang="lang"
        :first-day-of-week="1"
        :days-disabled-start="disableDaysAfterToday"
        :sync-range.sync="dateRange"
        @change="onChange"
        :month-year-format="'MMMM YYYY'"
      />
      <v-divider></v-divider>
      <v-layout row justify-space-between>
      <v-card-text class="text-xs-left">
        <v-flex xs5>
          <p><strong>Algus:</strong> {{ formatDate(dateRange.startDate) }}</p>
        </v-flex>
        <v-flex xs5>
          <p><strong>Lõpp:</strong> {{ formatDate(dateRange.endDate) }}</p>
        </v-flex>
      </v-card-text>
      <v-card-actions class="text-xs-right">
        <v-btn right color="success" outline large @click.native="searchByDates"><v-icon>search</v-icon></v-btn>
      </v-card-actions>
    </v-layout>
    </v-card>
  </v-dialog>
</v-container>
</template>

<script>
import {DateRange} from 'vue-date-range'
import moment from 'moment'
import Bugsnag from '../services/Bugsnag'
import TransactionService from '../services/TransactionsService'
import SubscriptionsService from '../services/SubscriptionsService'

export default {
  name: 'Calendar',
  data () {
    return {
      lang: 'en',
      disableDaysAfterToday: moment().add('1', 'days'),
      dateRange: {
        startDate: undefined,
        endDate: undefined
      }
    }
  },

  components: {
    DateRange
  },

  computed: {
    calendar: {
      get: function () {
        return this.$store.state.calendar
      },
      set: function (newValue) {
        this.$store.commit('setCalendar', false)
      }
    }
  },

  methods: {
    onChange (dateRange) {
      let formatedDatarange = this.formatDateRange(dateRange)
      this.$store.commit('setDateRange', formatedDatarange)
    },
    formatDateRange (dateRange) {
      return {
        startDate: dateRange.startDate.toISOString(),
        endDate: dateRange.endDate.toISOString()
      }
    },
    async searchByDates () {
      try {
        let dateRangeStart = this.$store.state.dateRange.startDate
        let dateRangeEnd = this.$store.state.dateRange.endDate
        let searchQuery = {
          dates: {
            startDate: dateRangeStart,
            endDate: dateRangeEnd
          }
        }
        let collectionType = this.$route.name.toLowerCase()
        if (collectionType === 'transactions') {
          let { limit, page } = this.$store.state.transactions
          let response = await TransactionService.search({searchQuery, page, limit})
          this.$store.commit('setTransactions', response.data)
        } else if (collectionType === 'subscriptions') {
          let { limit, page } = this.$store.state.subscriptions
          let response = await SubscriptionsService.search({searchQuery, page, limit})
          this.$store.commit('setSubscriptions', response.data)
        } else {
          console.error('unknown collection')
        }
      } catch (error) {
        this.error = error.message
        Bugsnag.send(error)
      } finally {
        this.$store.commit('setCalendar', false)
      }
    },

    formatDate (date) {
      return date ? moment(date).format('DD.MM.YYYY') : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Calendar.vue